import { render, staticRenderFns } from "./PositionUserWindow.vue?vue&type=template&id=0adc5064&scoped=true&"
import script from "./PositionUserWindow.vue?vue&type=script&lang=js&"
export * from "./PositionUserWindow.vue?vue&type=script&lang=js&"
import style0 from "./PositionUserWindow.vue?vue&type=style&index=0&id=0adc5064&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adc5064",
  null
  
)

export default component.exports